import {createSlice} from '@reduxjs/toolkit'

const initialSiteState = {
  site: null,
  sitesDropdown: [],
  isSiteLimitReachedDialog: false,
}

export const SiteSlices = createSlice({
  name: 'sites',
  initialState: initialSiteState,
  reducers: {
    site: (state, action) => {
      state.site = action.payload.site
    },
    sitesList: (state, action) => {
      state.sitesDropdown = action.payload.sites
    },
    setSiteLimitReachedDialog: (state, action) => {
      state.isSiteLimitReachedDialog = action.payload
    },
    resetSite: (state) => {
      state.site = null
    },
  },
})
